/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Chat from "./Chat";
import emptyimg from "../../assets/Image/emptyOrder.png";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import { IoClose } from "react-icons/io5";
import {
  LuCalendar,
  LuMessageSquare,
  LuPhoneCall,
  LuUserCheck,
  LuVideo,
} from "react-icons/lu";

const MyBooking = () => {
  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [currentBooking, setCurrentBooking] = useState([]);
  const [pastBooking, setPastBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [selectDoc, setSelectDoc] = useState("");
  const [deviceCheck, setDeviceCheck] = useState(false);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);
  const [apiLoading, setApiLoading] = useState(true);

  const navigate = useNavigate();
  const SelectBtnRef = useRef(0);
  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    HandleGetCurrentBooking(1);
  }, []);

  const HandleGetCurrentBooking = (page) => {
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/booked_appo_pending_list`, {
          id: Userid,
          page,
        })
        .then((res) => {
          const { pending_appoint_list, ResponseCode } = res.data;

          if (ResponseCode === 200) {
            if (
              pending_appoint_list.length === 0 ||
              totallength > pending_appoint_list.length
            ) {
              NoMoreDataRef.current = false;
            }

            if (page === 1) {
              setCurrentBooking(pending_appoint_list);
              setTotalLength(pending_appoint_list.length);
            } else {
              setCurrentBooking((prev) => [...prev, ...pending_appoint_list]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleGetPastBooking = (page) => {
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/booked_appo_complete_list`, {
          id: Userid,
          page,
        })
        .then((res) => {
          console.log("booked_appo_complete_list", res);
          const { complete_appoint_list, ResponseCode } = res.data;
          if (ResponseCode === 200) {
            if (
              complete_appoint_list.length === 0 ||
              totallength > complete_appoint_list.length
            ) {
              NoMoreDataRef.current = false;
            }

            if (page === 1) {
              setPastBooking(complete_appoint_list);
              setTotalLength(complete_appoint_list.length);
            } else {
              setPastBooking((prev) => [...prev, ...complete_appoint_list]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage((prevPage) => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current) return;

    if (SelectBtnRef.current === 0) {
      HandleGetCurrentBooking(page);
    } else {
      HandleGetPastBooking(page);
    }
  }, [page]);

  const HandleBookingDetails = (id) => {
    sessionStorage.setItem("Appintmentid", id);
    navigate("/appointment-details", {
      state: { status: SelectBtnRef.current },
    });
  };

  const HandleChat = (e, Docid) => {
    e.stopPropagation();
    setShowChat(true);
    setSelectDoc(Docid);
  };

  const AudioCallHandler = async (e, code, phone) => {
    e.stopPropagation();

    try {
      const deviceList = await navigator.mediaDevices.enumerateDevices();
      let hasMicrophone = false;

      deviceList.forEach((device) => {
        if (device.kind === "audioinput") {
          hasMicrophone = true;
        }
      });

      if (!hasMicrophone) {
        setDeviceCheck(true);
        return;
      }
    } catch (error) {
      console.error("Error checking devices:", error);
    }
    window.location.href = `tel:${code + phone}`;
  };

  const HadnleSelectButton = (index) => {
    SelectBtnRef.current = index;
    NoMoreDataRef.current = true;
    setPage(1);
    setTotalLength(0);
    if (index === 0) {
      HandleGetCurrentBooking(1);
    } else {
      HandleGetPastBooking(1);
    }
  };

  return (
    <div className="w-full width-container pb-[80px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading
          CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]"
          index={0}
        />
      ) : (
        <div className="flex flex-col">
          {/* Header Breadcrumbs/Tab selector */}
          <div className="flex justify-center mt-4 mb-8">
            <div className="bg-slate-100 p-1.5 rounded-full flex gap-1 max-w-md w-full sm:w-auto">
              <button
                onClick={() => HadnleSelectButton(0)}
                className={`flex-1 sm:flex-none px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${SelectBtnRef.current === 0 ? "bg-white text-indigo-600" : "text-slate-500 hover:text-slate-800"}`}
              >
                {t("Current Booking")}
              </button>
              <button
                onClick={() => HadnleSelectButton(1)}
                className={`flex-1 sm:flex-none px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${SelectBtnRef.current === 1 ? "bg-white text-indigo-600" : "text-slate-500 hover:text-slate-800"}`}
              >
                {t("Past Booking")}
              </button>
            </div>
          </div>

          {/* Bookings Card Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {SelectBtnRef.current === 0 ? (
                currentBooking.length >= 1 ? (
                  currentBooking.map((item, index) => {
                    const BgColor =
                      item.status_type === "Pending"
                        ? "bg-amber-50 text-amber-700 border border-amber-100"
                        : item.status_type === "Service Start"
                          ? "bg-orange-50 text-orange-600 border border-orange-100"
                          : "bg-indigo-50 text-indigo-700 border border-indigo-100";
                    return (
                      <div
                        onClick={() => HandleBookingDetails(item.id)}
                        key={index}
                        className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between"
                      >
                        <div className="relative h-44 overflow-hidden bg-slate-100 shrink-0 border-b border-slate-100">
                          <ImageLoad
                            src={ImgBaseUrl + item.doc_logo}
                            CustomeStyle="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            alt={item.name}
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent opacity-60"></div>
                          <div
                            className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-bold shadow-sm ${BgColor}`}
                          >
                            {item.status_type}
                          </div>
                        </div>
                        <div className="p-5 flex-1 flex flex-col justify-between">
                          <div>
                            <div className="flex items-center justify-between gap-2 mb-2.5">
                              <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block truncate">
                                {item.depart_name}
                              </span>
                              <span className="font-semibold text-xs text-indigo-600 bg-indigo-50 border border-indigo-100 rounded-full px-2.5 py-0.5 shrink-0">
                                {t("ID")}: {item.id}
                              </span>
                            </div>

                            <h3 className="font-bold text-slate-800 text-lg group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full mb-3">
                              {item.name}
                            </h3>

                            {/* Date Time Slot display */}
                            <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold bg-slate-50 p-2.5 rounded-xl border border-slate-100 mb-3">
                              <LuCalendar className="w-4 h-4 text-slate-400 shrink-0" />
                              <span className="truncate">
                                {item.appointment_date} @{" "}
                                {item.appointment_time}
                              </span>
                            </div>

                            {/* Visit Type pill */}
                            <div className="flex items-center gap-2 text-xs font-bold w-fit px-2.5 py-1 rounded-full bg-indigo-50/70 text-indigo-700 border border-indigo-100/50">
                              {item.show_type === "1" ? (
                                <>
                                  <LuUserCheck className="w-3.5 h-3.5" />
                                  <span>{t("In Person Visit")}</span>
                                </>
                              ) : (
                                <>
                                  <LuVideo className="w-3.5 h-3.5" />
                                  <span>{t("Video Consult")}</span>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Action buttons */}
                          <div className="mt-5 pt-4 border-t border-slate-100 flex items-center gap-3">
                            <button
                              onClick={(e) => HandleChat(e, item.did)}
                              className="flex-1 py-2.5 px-4 bg-slate-50 border border-slate-200 hover:border-indigo-200 hover:bg-indigo-50/20 hover:text-indigo-600 text-slate-700 rounded-xl font-semibold text-xs transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5 shadow-sm"
                            >
                              <LuMessageSquare className="w-4 h-4 text-slate-500 group-hover:text-indigo-600 shrink-0" />
                              <span>{t("Message")}</span>
                            </button>

                            <button
                              onClick={(e) =>
                                AudioCallHandler(
                                  e,
                                  item.country_code,
                                  item.phone,
                                )
                              }
                              className="flex-1 py-2.5 px-4 bg-slate-50 border border-slate-200 hover:border-indigo-200 hover:bg-indigo-50/20 hover:text-indigo-600 text-slate-700 rounded-xl font-semibold text-xs transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5 shadow-sm"
                            >
                              <LuPhoneCall className="w-4 h-4 text-slate-500 group-hover:text-indigo-600 shrink-0" />
                              <span>{t("Call")}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-span-full bg-slate-50 rounded-3xl p-10 flex flex-col items-center justify-center text-center border border-dashed border-slate-200/80">
                    <img
                      src={emptyimg}
                      className="w-44 opacity-80 mb-4"
                      alt=""
                    />
                    <h3 className="font-bold text-slate-800 text-lg">
                      {t("No Bookings Found")}
                    </h3>
                    <p className="text-slate-500 text-sm max-w-xs mt-1">
                      {t(
                        "Currently you don't have any pending doctor appointments scheduled.",
                      )}
                    </p>
                  </div>
                )
              ) : pastBooking.length >= 1 ? (
                pastBooking.map((item, index) => {
                  const BgColor =
                    item.status_type === "Canceled"
                      ? "bg-rose-50 text-rose-600 border border-rose-100"
                      : "bg-emerald-50 text-emerald-700 border border-emerald-100";
                  return (
                    <div
                      onClick={() => HandleBookingDetails(item.id)}
                      key={index}
                      className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between"
                    >
                      {/* Card Banner Cover / Doc Image */}
                      <div className="relative h-44 overflow-hidden bg-slate-100 shrink-0 border-b border-slate-100">
                        <ImageLoad
                          src={ImgBaseUrl + item.doc_logo}
                          CustomeStyle="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          alt={item.name}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent opacity-60"></div>
                        <div
                          className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-bold shadow-sm ${BgColor}`}
                        >
                          {item.status_type}
                        </div>
                      </div>

                      {/* Card Body */}
                      <div className="p-5 flex-1 flex flex-col justify-between">
                        <div>
                          <div className="flex items-center justify-between gap-2 mb-2.5">
                            <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block truncate">
                              {item.depart_name}
                            </span>
                            <span className="font-semibold text-xs text-indigo-600 bg-indigo-50 border border-indigo-100 rounded-full px-2.5 py-0.5 shrink-0">
                              {t("ID")}: {item.id}
                            </span>
                          </div>

                          <h3 className="font-bold text-slate-800 text-lg group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full mb-3">
                            {item.name}
                          </h3>

                          {/* Date Time Slot display */}
                          <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold bg-slate-50 p-2.5 rounded-xl border border-slate-100 mb-3">
                            <LuCalendar className="w-4 h-4 text-slate-400 shrink-0" />
                            <span className="truncate">
                              {item.appointment_date} @ {item.appointment_time}
                            </span>
                          </div>

                          {/* Visit Type pill */}
                          <div className="flex items-center gap-2 text-xs font-bold w-fit px-2.5 py-1 rounded-full bg-indigo-50/70 text-indigo-700 border border-indigo-100/50">
                            {item.show_type === "1" ? (
                              <>
                                <LuUserCheck className="w-3.5 h-3.5" />
                                <span>{t("In Person Visit")}</span>
                              </>
                            ) : (
                              <>
                                <LuVideo className="w-3.5 h-3.5" />
                                <span>{t("Video Consult")}</span>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Action buttons */}
                        <div className="mt-5 pt-4 border-t border-slate-100 flex items-center gap-3">
                          <button
                            onClick={(e) => HandleChat(e, item.did)}
                            className="flex-1 py-2.5 px-4 bg-slate-50 border border-slate-200 hover:border-indigo-200 hover:bg-indigo-50/20 hover:text-indigo-600 text-slate-700 rounded-xl font-semibold text-xs transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5 shadow-sm"
                          >
                            <LuMessageSquare className="w-4 h-4 text-slate-500 shrink-0" />
                            <span>{t("Message")}</span>
                          </button>

                          <button
                            onClick={(e) =>
                              AudioCallHandler(e, item.country_code, item.phone)
                            }
                            className="flex-1 py-2.5 px-4 bg-slate-50 border border-slate-200 hover:border-indigo-200 hover:bg-indigo-50/20 hover:text-indigo-600 text-slate-700 rounded-xl font-semibold text-xs transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5 shadow-sm"
                          >
                            <LuPhoneCall className="w-4 h-4 text-slate-500 shrink-0" />
                            <span>{t("Call")}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-full bg-slate-50 rounded-3xl p-10 flex flex-col items-center justify-center text-center border border-dashed border-slate-200/80">
                  <img src={emptyimg} className="w-44 opacity-80 mb-4" alt="" />
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("No Bookings Found")}
                  </h3>
                  <p className="text-slate-500 text-sm max-w-xs mt-1">
                    {t(
                      "Currently you don't have any past doctor appointments recorded.",
                    )}
                  </p>
                </div>
              )}
          </div>
        </div>
      )}

      {/* Chat bottom overlay sheet */}
      {showChat && (
        <div
          onClick={() => setShowChat(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-xl w-full max-h-[85vh] flex flex-col p-6 relative overflow-hidden"
          >
            <button
              onClick={() => setShowChat(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close chat"
            >
              <IoClose className="w-6 h-6" />
            </button>
            <div className="flex-1 mt-2 overflow-hidden flex flex-col">
              <Chat index={1} setShowChat={setShowChat} doctorId={selectDoc} />
            </div>
          </div>
        </div>
      )}

      {/* Device micro check alert */}
      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-sm w-full text-center"
          >
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4 border border-amber-100">
              <LuPhoneCall className="w-6 h-6" />
            </div>
            <h2 className="font-bold text-slate-800 text-lg mb-2">
              {t("Audio Input Required")}
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed">
              {t(
                "Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.",
              )}
            </p>
            <button
              onClick={() => setDeviceCheck(false)}
              className="mt-5 w-full py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-xl text-sm transition-all duration-150 active:scale-98"
            >
              {t("Got It")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyBooking;
/* jshint ignore:end */
